import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-7b42d640"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "gap-x-10",
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_2 = { class: "" }
const _hoisted_3 = {
  class: "",
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_4 = {
  style: {"color":"var(--cm-color-text-secondary)"},
  class: "cm-ui-ml10"
}
const _hoisted_5 = {
  class: "cm-align-center",
  style: {"color":"var(--cm-color-text-primary)","margin-top":"10px"}
}
const _hoisted_6 = { class: "cm-ui-mt20" }
const _hoisted_7 = {
  style: {"font-weight":"bold"},
  class: "cm-ui-mt10 cm-ui-mb10"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-arrow-right" }, null, -1))
const _hoisted_9 = {
  class: "",
  style: {"color":"var(--cm-color-text-primary)"}
}
const _hoisted_10 = { class: "" }
const _hoisted_11 = { style: {"font-size":"14px"} }
const _hoisted_12 = {
  class: "",
  style: {"overflow-y":"scroll","flex":"1 1 auto"}
}
const _hoisted_13 = {
  key: 0,
  class: "",
  style: {"display":"grid","gap":"10px","grid-template-columns":"repeat(3, 1fr)"}
}
const _hoisted_14 = ["title"]
const _hoisted_15 = {
  class: "cm-ui-mt10",
  style: {"color":"var(--cm-color-text-secondary)","font-size":"14px"}
}

import { getSvgIconDataUrl } from '@/utils/svg-icon-data-url'
import { computed, ref, reactive, onMounted } from 'vue'
import CmFormItem from '@/components/cmForm/FormItem.vue'
import { FormType } from '@/components/cmForm/types'
import { AuthInfo, AuthState } from '@/services/system-auth.service'
import { systemAuthService } from '@/common/basis/root-injector'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { AuthorizeInfoService } from '@/views/authorize/authorize-info.service'
import { MySubscribeService, ServiceList } from '@/views/dashboard/service/my-subscribe/my-subscribe.service'
import { ServiceType } from '@/views/dashboard/_enum/service-type'
import { ServiceStatus, ServiceStatusColor, ServiceStatusLabel } from '@/views/dashboard/service/_enum/service-status'
import AuthorizeInfo from '@/views/authorize/authorize-info.vue'
import { formatTimeStamp } from '@/utils/time'
import { useParseTime } from '@/hooks'
import Copy from '@/views/_components/copy/copy.vue'
import { TerminalType } from '@/views/dashboard/_enum/terminal-type'
import { AssetStatusService } from '../../asset-status/asset-status.service'
import dayjs from 'dayjs'
import { useI18n } from 'vue-i18n'
import { getElColorPrimaryRgba } from '@/utils/theme-color'


export default /*#__PURE__*/_defineComponent({
  __name: 'auth-dialog',
  props: {
  modelValue: {
    type: Boolean,
    default: false
  }
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const { t, locale } = useI18n()

const authCardBodyStyle = computed(() => {
  const tint = getElColorPrimaryRgba(0.2)
  return {
    backgroundColor: tint,
    borderColor: tint,
    padding: '24px',
  }
})
const injector = useReflectiveInjector([AuthorizeInfoService, MySubscribeService, AssetStatusService])
const service = injector.get(MySubscribeService)
const assetStatusService = injector.get(AssetStatusService)
const props = __props

const isLoading = ref(false)
const formCurrent = reactive({ currentType: TerminalType.windows })
const emit = __emit
const visible = computed({
  get: () => props.modelValue,
  set: (val) => {
    emit('update:modelValue', val)
  },
})
const authInfo = ref({} as AuthInfo)
const form = ref({} as { deploy_ip: string })

const authIconName = computed(() => {
  const imgName = authInfo.value.authorize_state === AuthState.authed ? 'auth' : 'unauth'
  return `views/dashboard/home/_components/service-info/_images/${imgName}`
})
const osCounts = reactive({
  windows: 0,
  server: 0,
  linux: 0,
})

const currentFormItem = computed(() => {
  void locale.value
  return {
    colOpt: { span: 24, style: 'padding:0' },
    hiddenAllLabel: true,
    radioGroupOpt: { style: 'margin:0;display:grid;grid-template-columns:repeat(3,1fr);gap:10px' },
    type: FormType.RadioCm,
    dictData: [
      { label: t('authDialog.osWindows'), value: TerminalType.windows, num: osCounts.windows },
      { label: t('authDialog.osWindowsServer'), value: TerminalType.windowsServer, num: osCounts.server },
      { label: t('authDialog.osLinux'), value: TerminalType.linux, num: osCounts.linux },
    ],
  }
})

const subscribeList = ref<ServiceList[]>([])
const filterList = computed(() => subscribeList.value.filter(item => item.support_system_types.includes(formCurrent.currentType)))

const authorizeStateLabel = computed(() => {
  void locale.value
  const s = authInfo.value?.authorize_state
  if (s === AuthState.notAuth) return t('authDialog.authState0')
  if (s === AuthState.authed) return t('authDialog.authState1')
  if (s === AuthState.authExpired) return t('authDialog.authState2')
  return ''
})

const getDataList = () => {
  isLoading.value = true
  service.getSubscribeList({
    page: 1,
    limit: 99999,
  }).then(response => {
    subscribeList.value = response.service_list
  }).finally(() => {
    isLoading.value = false
  })
}
const assessStatusData = async () => {
  const range = [dayjs().subtract(30, 'day').format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')]
  const [st, et] = useParseTime(range)
  const result = await assetStatusService.getAssetStatus({
    start_time: st != null ? String(st) : undefined,
    end_time: et != null ? String(et) : undefined,
  })
  osCounts.windows = result.windows_terminal_count || 0
  osCounts.server = result.server_terminal_count || 0
  osCounts.linux = result.linux_terminal_count || 0
}
onMounted(() => {
  systemAuthService.updateAuthInfoEvent.subscribe((info) => {
    authInfo.value = info
    form.value.deploy_ip = info.deploy_ip
  })
  systemAuthService.updateRemoteAuthInfo()
  void assessStatusData()
  getDataList()
})

return (_ctx: any,_cache: any) => {
  const _component_CmSvgIcon = _resolveComponent("CmSvgIcon")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "append-to-body": "",
    title: _ctx.$t('authDialog.dialogTitle'),
    modelValue: visible.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((visible).value = $event)),
    width: 760
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_card, {
        shadow: "none",
        "body-style": authCardBodyStyle.value
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_CmSvgIcon, {
              name: authIconName.value,
              size: 48,
              monochrome: "",
              color: "var(--el-color-primary)"
            }, null, 8, ["name"]),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("h2", {
                  style: _normalizeStyle([{"line-height":"1em","font-size":"18px"}, { color: authInfo.value.authorize_state === _unref(AuthState).authed ? 'var(--el-color-primary)' : 'var(--cm-color-text-secondary)' }])
                }, _toDisplayString(authorizeStateLabel.value), 5),
                _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(formatTimeStamp)(authInfo.value.authorize_start_time * 1000, `YYYY-MM-DD`)) + " " + _toDisplayString(_ctx.$t('common.dateRangeSeparator')) + " " + _toDisplayString(_unref(formatTimeStamp)(authInfo.value.authorize_end_time * 1000, `YYYY-MM-DD`)), 1)
              ]),
              _createElementVNode("p", _hoisted_5, [
                _createTextVNode(_toDisplayString(_ctx.$t('authDialog.applyCodeLabel')) + " ", 1),
                _createVNode(Copy, { class: "cm-ui-ml15" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(authInfo.value.apply_code), 1)
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["body-style"]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(AuthorizeInfo, { flag: true })
      ]),
      _createVNode(_component_el_row, {
        class: "bar cm-ui-mt10",
        justify: "space-between",
        align: "middle"
      }, {
        default: _withCtx(() => [
          _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t('authDialog.deployedSectionTitle')), 1),
          _createVNode(_component_router_link, {
            style: {"line-height":"1em","color":"var(--el-color-primary)","text-decoration":"none"},
            to: "/dashboard/my-subscribe"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('authDialog.mySubscribe')) + " ", 1),
              _hoisted_8
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_card, {
        shadow: "none",
        bodyStyle: "padding: 10px;max-height: 320px;display:flex;flex-direction: column;justify-content:space-between"
      }, {
        default: _withCtx(() => [
          _createVNode(CmFormItem, {
            prop: "currentType",
            modelValue: formCurrent,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formCurrent) = $event)),
            formItem: currentFormItem.value
          }, {
            "currentType-radio-title": _withCtx(({ title, item }) => [
              _createElementVNode("div", _hoisted_9, [
                _createTextVNode(_toDisplayString(title) + " ", 1),
                _createElementVNode("h2", _hoisted_10, [
                  _createTextVNode(_toDisplayString(item.num) + " ", 1),
                  _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('authDialog.unitTai')), 1)
                ])
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "formItem"]),
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_12, [
            (filterList.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filterList.value, (item) => {
                    return (_openBlock(), _createBlock(_component_el_card, {
                      shadow: "none",
                      bodyStyle: "padding: 14px;overflow:hidden;position: relative;",
                      key: item.price_id
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: "tag",
                          style: _normalizeStyle(item.type === _unref(ServiceType).experience ? { backgroundColor: _unref(ServiceStatusColor)[_unref(ServiceStatus).trying] } : { backgroundColor: _unref(ServiceStatusColor)[item.status] })
                        }, [
                          (item.type === _unref(ServiceType).experience)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(_unref(ServiceStatusLabel)[_unref(ServiceStatus).trying]), 1)
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(_toDisplayString(_unref(ServiceStatusLabel)[item.status]), 1)
                              ], 64))
                        ], 4),
                        _createElementVNode("div", {
                          class: "title cm-ellipsis-line-one",
                          title: item.display_name,
                          style: {"color":"var(--cm-color-text-primary)"}
                        }, _toDisplayString(item.display_name), 9, _hoisted_14),
                        _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('authDialog.configuredSubscribed', { configured: item.count, subscribed: item.terminal_count })), 1)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]))
              : (_openBlock(), _createBlock(_component_el_empty, {
                  key: 1,
                  "image-size": 120,
                  image: _unref(getSvgIconDataUrl)(_ctx.EMPTY_TABLE_SVG_ICON),
                  description: _ctx.$t('common.noData')
                }, null, 8, ["image", "description"]))
          ])), [
            [_directive_loading, isLoading.value]
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["title", "modelValue"]))
}
}

})